import type { RelationshipRow } from '@/services/crmRelationships'
import { BAND_STYLE, healthDescription, healthLabel } from './relationshipFormat'

/**
 * The health ring: the score in the middle, the arc proportional to it.
 *
 * Colour is a second cue, never the only one: the number is printed in the
 * ring, the band word is in the title, and a contact with no score draws an
 * empty track with "NEW" or a dash instead of a number. A ring is never drawn
 * from a figure the record does not support.
 */
export default function HealthRing({
  row,
  size = 34,
  className,
}: {
  row: Pick<RelationshipRow, 'health' | 'healthBand' | 'stage'> | undefined
  size?: number
  className?: string
}) {
  const score = row?.health ?? null
  const band = row?.healthBand ?? null
  const label = healthDescription(row)
  const stroke = band ? BAND_STYLE[band].stroke : '#4b4b4b'
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      role="img"
      aria-label={label}
      className={className}
      data-testid="health-ring"
    >
      <title>{label}</title>
      <circle cx="18" cy="18" r="15.9155" fill="none" stroke="#262626" strokeWidth="3.2" />
      {score !== null ? (
        <circle
          cx="18"
          cy="18"
          r="15.9155"
          fill="none"
          stroke={stroke}
          strokeWidth="3.2"
          strokeDasharray={`${score} ${100 - score}`}
          strokeLinecap="round"
          transform="rotate(-90 18 18)"
        />
      ) : null}
      <text x="18" y="21.2" textAnchor="middle" fontSize="9.5" fontWeight="600" fill="#ece9e1" fontFamily="Inter, sans-serif">
        {healthLabel(row)}
      </text>
    </svg>
  )
}
